import React, { useEffect, useState } from 'react';
import './Wizard.css';
import WizardStep from './WizardStep';
import { isValid } from '../_utils';
var Wizard = function (props) {
    var height = props.height, _a = props.hideButtons, hideButtons = _a === void 0 ? false : _a, _b = props.selectedStep, selectedStep = _b === void 0 ? 1 : _b, _c = props.fullPageWizard, fullPageWizard = _c === void 0 ? true : _c, _d = props.btnNextText, btnNextText = _d === void 0 ? 'Next' : _d, _e = props.btnPreviousText, btnPreviousText = _e === void 0 ? 'Previous' : _e, _f = props.btnCancelText, btnCancelText = _f === void 0 ? 'Cancel' : _f, _g = props.btnFinishText, btnFinishText = _g === void 0 ? 'Save' : _g, onStepChanged = props.onStepChanged, onFinished = props.onFinished, onCancelled = props.onCancelled, children = props.children, className = props.className;
    var _h = useState([]), steps = _h[0], setSteps = _h[1];
    var _j = useState(selectedStep), selectedStepId = _j[0], setSelectedStepId = _j[1];
    isValid((React.createElement(Wizard, null)).type.name, (React.createElement(WizardStep, null)).type.name, children);
    useEffect(function () {
        if (children) {
            var index_1 = 0;
            var allSteps_1 = [];
            children.forEach(function (child) {
                index_1++;
                if (child === null || child === void 0 ? void 0 : child.props) {
                    var _a = child === null || child === void 0 ? void 0 : child.props, title = _a.title, disabled = _a.disabled, error = _a.error, children_1 = _a.children;
                    allSteps_1.push({
                        id: index_1,
                        title: title,
                        disabled: disabled,
                        error: error,
                        children: children_1
                    });
                }
            });
            setSteps(allSteps_1);
        }
    }, [children]);
    var getNextStep = function () {
        var nextStepId = selectedStepId + 1;
        return nextStepId <= steps.length ? steps[nextStepId - 1] : null;
    };
    var getPreviousStep = function () {
        var previousStepId = selectedStepId - 1;
        return previousStepId >= 1 ? steps[previousStepId - 1] : null;
    };
    var visibleNavButtons = function () { return navButtons(); };
    var navButtons = function () { return [btnPrevious(), btnNext()]; };
    var visibleActionButtons = function () { return actionButtons().filter(function (a) { return !a.hide; }); };
    var actionButtons = function () { return [btnCancel(), btnFinish()]; };
    var btnPrevious = function () {
        var previousStep = getPreviousStep();
        return {
            id: 'btnPrevious',
            class: 'btn btn-light',
            click: function () {
                if (previousStep) {
                    setSelectedStepId(previousStep.id);
                    onStepChanged === null || onStepChanged === void 0 ? void 0 : onStepChanged(previousStep);
                }
            },
            disabled: !previousStep || previousStep.disabled,
            icon: {
                position: 'left',
                class: 'fa fa-arrow-left'
            },
            text: btnPreviousText,
            hide: !previousStep
        };
    };
    var btnNext = function () {
        var nextStep = getNextStep();
        return {
            id: 'btnNext',
            class: 'btn btn-primary',
            click: function () {
                if (nextStep) {
                    setSelectedStepId(nextStep.id);
                    onStepChanged === null || onStepChanged === void 0 ? void 0 : onStepChanged(nextStep);
                }
            },
            disabled: !nextStep || nextStep.disabled,
            icon: {
                position: 'right',
                class: 'fa fa-arrow-right icon-white'
            },
            text: btnNextText,
            hide: !nextStep
        };
    };
    var btnFinish = function () {
        var nextStep = getNextStep();
        return {
            id: 'btnFinish',
            class: "btn btn-" + (nextStep ? 'light' : 'primary'),
            click: function () { return onFinished === null || onFinished === void 0 ? void 0 : onFinished(); },
            disabled: false,
            text: btnFinishText,
            hide: false
        };
    };
    var btnCancel = function () {
        return {
            id: 'btnCancel',
            class: 'btn btn-light',
            click: function () { return onCancelled === null || onCancelled === void 0 ? void 0 : onCancelled(); },
            text: btnCancelText,
            hide: false
        };
    };
    var renderButtons = function (buttons, customClass, className, align, hideButtons) {
        if (hideButtons === void 0) { hideButtons = false; }
        return (React.createElement("div", { className: className + " text-" + align }, !hideButtons && (React.createElement("div", { className: customClass }, buttons === null || buttons === void 0 ? void 0 : buttons.map(function (btn) {
            var _a;
            return (React.createElement("button", { id: btn.id, key: btn.id, className: "mr-1 " + btn.class, type: "button", disabled: btn.disabled, onClick: btn.click },
                btn.icon &&
                    (btn.icon.position === 'left' ||
                        !btn.icon.position) && (React.createElement("span", null,
                    React.createElement("i", { className: btn.icon.class }),
                    "\u00A0\u00A0")),
                btn.text,
                ((_a = btn.icon) === null || _a === void 0 ? void 0 : _a.position) === 'right' && (React.createElement("span", null,
                    "\u00A0\u00A0",
                    React.createElement("i", { className: btn.icon.class })))));
        })))));
    };
    var currentStep = steps === null || steps === void 0 ? void 0 : steps.find(function (s) { return s.id === selectedStepId; });
    return (React.createElement("div", { className: "wizard" + (className ? " " + className : '') + " ml-0 mr-0 mb-2" },
        React.createElement("ul", { className: "nav nav-pills nav-justified justify-content-center dnvgl-nav-pills mb-2" }, steps === null || steps === void 0 ? void 0 : steps.map(function (step) { return (React.createElement("li", { className: (step.error ? 'border border-danger ' : '') + "nav-item", key: step.id },
            React.createElement("a", { className: "" + (step.disabled ? 'disabled ' : '') + (selectedStepId === step.id ? 'active ' : '') + "nav-link fade-item", style: {
                    opacity: step.disabled ? 0.5 : 'auto'
                }, onClick: function () {
                    setSelectedStepId(step.id);
                    onStepChanged === null || onStepChanged === void 0 ? void 0 : onStepChanged(step);
                } },
                React.createElement("span", { className: "badge badge-outline-info" }, step.id),
                React.createElement("h4", null, step.title)))); })),
        React.createElement("div", { className: "d-lg-flex justify-content-center" + (fullPageWizard ? ' wizardBackground' : ''), style: height
                ? {
                    height: height,
                    overflowY: 'auto',
                    position: 'relative'
                }
                : undefined }, currentStep && (React.createElement(WizardStep, { title: currentStep.title }, currentStep.children))),
        !!fullPageWizard && !hideButtons && (React.createElement("div", { className: "row fixedfooter" },
            React.createElement("div", { className: "col-4" }),
            renderButtons(visibleNavButtons(), 'mt-2', 'col-4', 'center', hideButtons),
            renderButtons(visibleActionButtons(), 'mt-2', 'col-4', 'center', hideButtons))),
        !fullPageWizard && !hideButtons && (React.createElement("div", { className: "row modalfooter ml-0 mr-0 mb-2" },
            renderButtons(visibleNavButtons(), 'pt-3 wizard-navigation-buttons-container', 'col-6', 'left', hideButtons),
            renderButtons(visibleActionButtons(), 'mt-3 wizard-footer', 'col-6', 'right', hideButtons)))));
};
export default React.memo(Wizard);
